<template>
  <v-container fluid>
    <v-row class="text-center">
      <v-col xs="12" class="pb-3 headline" md2>
        Update Password
      </v-col>
    </v-row>
    <v-form v-model="isValid">
      <v-row justify="center">
        <v-col xs="12" lg="4" px-2>
          <v-text-field v-model="currentPassword"
                        :append-icon="showCurrentPassword ? 'mdi-eye' : 'mdi-eye-off'"
                        :rules="[rules.required]"
                        :type="showCurrentPassword ? 'text' : 'password'"
                        name="input-10-1"
                        label="Current Password"
                        @click:append="showCurrentPassword = !showCurrentPassword" />
        </v-col>
      </v-row>

      <v-row justify="center">
        <v-col xs="12" lg="4" px-2>
          <v-text-field v-model="newPassword"
                        :append-icon="showNewPassword ? 'mdi-eye' : 'mdi-eye-off'"
                        :rules="[rules.required, strong]"
                        :type="showNewPassword ? 'text' : 'password'"
                        name="input-10-2"
                        label="New Password"
                        @click:append="showNewPassword = !showNewPassword" />
        </v-col>
      </v-row>

      <v-row justify="center">
        <v-col xs="12" lg="4" px-2>
          <v-text-field v-model="newPasswordRepeat"
                        :append-icon="showNewPasswordRepeat ? 'mdi-eye' : 'mdi-eye-off'"
                        :type="showNewPasswordRepeat ? 'text' : 'password'"
                        :rules="[rules.required, match]"
                        name="input-10-3"
                        label="Repeat New Password"
                        @click:append="showNewPasswordRepeat = !showNewPasswordRepeat" />
        </v-col>
      </v-row>

      <v-row justify="center">
        <v-col xs="12" lg="4" px-2>
          <v-btn :disabled="!isValid" :loading="updating" @click="updatePassword">Update</v-btn>
        </v-col>
      </v-row>
    </v-form>

    <v-snackbar v-model="showSnackbar" color="red">
      <v-icon v-if="updateError" class="white--text">mdi-alert</v-icon>
      <span>{{ snackbarText }}</span>
      <v-btn color="white" text @click="showSnackbar = false">
        Close
      </v-btn>
    </v-snackbar>
  </v-container>
</template>

<style>
  table.v-table tbody td:not(:nth-child(1)) {
    padding: 0 10px;
  }

  table.v-table thead th:not(:nth-child(1)) {
    padding: 0 10px;
  }
</style>

<script>

import userApi from '@/services/userApi-hshttp';

export default {
  data: function () {
    return {
      currentPassword: '',
      showCurrentPassword: false,
      newPassword: '',
      showNewPassword: false,
      newPasswordRepeat: '',
      showNewPasswordRepeat: false,
      rules: {
        required: value => !!value || 'Required.'
      },
      showSnackbar: false,
      snackbarText: '',
      updating: false,
      updateError: false,
      isValid: false,
      strongRegex: new RegExp('^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{12,})')
    };
  },
  computed: {
    updateDisabled: function () {
      return this.currentPassword === '' || this.newPassword === '' || (this.newPasswordRepeat !== this.newPassword);
    }
  },
  methods: {
    async updatePassword () {
      this.updating = true;

      var rs = await userApi.updatePassword(this.currentPassword, this.newPassword);
      if (!rs.ok) {
        this.updateError = true;
        this.showSnackbar = true;
        this.snackbarText = rs.error;
      } else {
        this.$router.replace({ path: '/' });
      }

      this.updating = false;
    },
    match: function (v) {
      return this.newPassword === v || 'Must match new password';
    },
    strong: function (v) {
      return this.strongRegex.test(v) || 'Password must include one lower-case letter, upper-case letter, number and be at least 12 characters long.';
    }
  }
};
</script>
